/* Clarity collection — filter drawer + auto-applying sort.
   Filtering/sorting themselves are native Shopify (GET form → collection URL);
   this only handles the drawer UI and submitting the sort form on change. */
(() => {
  const FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select, [tabindex]:not([tabindex="-1"])';
  let lastFocused = null;

  const overlayFor = (btn) => document.getElementById(btn.getAttribute('aria-controls'));
  const openOverlays = () => document.querySelectorAll('.clarity-col__overlay.is-open');

  function onKey(e) {
    if (e.key === 'Escape') {
      openOverlays().forEach(closeDrawer);
      return;
    }
    if (e.key !== 'Tab') return;
    const overlay = document.querySelector('.clarity-col__overlay.is-open');
    if (!overlay) return;
    // Include controls linked to the drawer's form via the form attribute.
    const nodes = [...overlay.querySelectorAll(FOCUSABLE)].filter((n) => n.offsetParent !== null);
    if (!nodes.length) return;
    const first = nodes[0];
    const last = nodes[nodes.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  function openDrawer(overlay, trigger) {
    if (!overlay) return;
    overlay.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
    lastFocused = trigger || document.activeElement;
    trigger?.setAttribute('aria-expanded', 'true');
    document.addEventListener('keydown', onKey);
    requestAnimationFrame(() => overlay.querySelector('.clarity-col__drawer-close')?.focus());
  }

  function closeDrawer(overlay) {
    if (!overlay || !overlay.classList.contains('is-open')) return;
    overlay.classList.remove('is-open');
    if (!openOverlays().length) {
      document.documentElement.style.overflow = '';
      document.removeEventListener('keydown', onKey);
    }
    const trigger = document.querySelector(`[data-open-filters][aria-controls="${overlay.id}"]`);
    trigger?.setAttribute('aria-expanded', 'false');
    (lastFocused || trigger)?.focus();
  }

  document.querySelectorAll('[data-open-filters]').forEach((btn) =>
    btn.addEventListener('click', () => openDrawer(overlayFor(btn), btn))
  );
  document.querySelectorAll('[data-close-filters]').forEach((el) =>
    el.addEventListener('click', () => closeDrawer(el.closest('.clarity-col__overlay')))
  );

  // Sort — apply immediately by submitting the associated facet form (which also
  // carries any active filter inputs, so the current filters are preserved).
  document.querySelectorAll('[data-clarity-sort]').forEach((sel) => {
    sel.addEventListener('change', () => {
      const form = sel.form || document.getElementById(sel.getAttribute('form'));
      if (form) form.submit();
    });
  });
})();
